import IColor from '@/models/IColor'
import lightness from 'lightness'
import fontColorContrast from 'font-color-contrast'

const light = 55
const dark = light * -1

export default [
  {
    label: 'Bleu',
    value: '#bfccdd'
  },
  {
    label: 'Rose',
    value: '#e6ccc6'
  },
  {
    label: 'Orange',
    value: '#ed9374'
  },
  {
    label: 'Jaune',
    value: '#f1dbbd'
  },
  {
    label: 'Vert',
    value: '#cfe4d9'
  },
  {
    label: 'Violet',
    value: '#b487fd'
  },
  {
    label: 'Gris',
    value: '#efedf5'
  },
  {
    label: 'Acier',
    value: '#566274'
  },
  {
    label: 'Vert Brasil',
    value: '#008c35'
  },
  {
    label: 'Jaune Brasil',
    value: '#ffdf00'
  },
  {
    label: 'Rouge sombre pastel',
    value: '#c03b22'
  },
  {
    label: `Perle d'eau`,
    value: '#76c5bf'
  },
  {
    label: 'Expresso',
    value: '#ab7642'
  },
  {
    label: 'Menthe',
    value: '#b3ffe1'
  },
  {
    label: 'Neige',
    value: '#fff6f6'
  },
  {
    label: 'Rose lavande',
    value: '#eea1eb'
  }
].map(
  (color: IColor): IColor => {
    const darkValue = lightness(color.value, dark).toLowerCase()
    const lightValue = lightness(color.value, light).toLowerCase()
    const slightLightValue = lightness(color.value, 10).toLowerCase()
    return {
      ...color,
      darkValue,
      lightValue,
      slightLightValue,
      constrastColor:
        fontColorContrast(color.value) === '#000000' ? darkValue : lightValue
    }
  }
)
